import { IEndUserCareer } from 'interfaces/CareerInterface'

export type CareerStatusText = 'Complete' | 'In Progress' | 'Learn More'

export const getCareerStatusText = (c: IEndUserCareer): CareerStatusText => {
  if (c.is_completed) return 'Complete'
  if (c.is_deep_dive) return 'In Progress'
  return 'Learn More'
}

export const getStatusPillClass = (text: CareerStatusText): string => {
  switch (text) {
    case 'Complete':
      return 'bg-action text-white'
    case 'In Progress':
      return 'bg-[#D4B07D] text-[#303030]'
    default:
      return 'bg-[#E8E8E8] text-[#303030]'
  }
}
